/* eslint-disable import/no-duplicates */
import React from 'react';

import { IAdSenseCredential } from '@domain/interfaces/dashboard/AdSense/IAdSenseCredential';

import { useTaboolaCredentials } from '@helpers/hooks/common/integrations/marketing/taboola/useTaboolaCredentials';
import { useToast } from '@helpers/hooks/useToast';

import { currencyFormatter, currencyToNumber } from '@helpers/masks';

import * as S from './styles';

interface ITaxModalProps {
  isOpen: boolean;
  toggle: () => void;
  selectedAdSenseCredential: IAdSenseCredential;
}

const TaxModal: React.FC<ITaxModalProps> = ({ isOpen, toggle, selectedAdSenseCredential }) => {
  const { updateAdSenseCredential, isUpdatingTaxRate } = useTaboolaCredentials();
  const { toast } = useToast();

  const DEFAULT_TAX_RATE = 13.83;

  const getTaxRate = React.useCallback(() => {
    return selectedAdSenseCredential.tax_percentage ?? DEFAULT_TAX_RATE;
  }, [selectedAdSenseCredential.tax_percentage]);

  const [taxRate, setTaxRate] = React.useState<number>(getTaxRate());

  React.useEffect(() => {
    setTaxRate(getTaxRate());
  }, [getTaxRate, selectedAdSenseCredential]);

  const onTaxRateChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const currencyFormatterValue = currencyFormatter(event.target.value);

    event.target.value = currencyFormatterValue;

    const currencyToNumberValue = currencyToNumber(currencyFormatterValue);

    setTaxRate(currencyToNumberValue);
  }, []);

  const handleSave = React.useCallback(async () => {
    if (taxRate === undefined || taxRate === null || Number.isNaN(taxRate)) {
      toast.error('Insira um valor para a taxa de imposto');
      return;
    }

    await updateAdSenseCredential(selectedAdSenseCredential.alias_id, taxRate);
    toggle();
  }, [taxRate, selectedAdSenseCredential.alias_id, updateAdSenseCredential, toggle, toast]);

  return (
    <S.Modal isOpen={isOpen} toggle={toggle}>
      <S.Header>
        <S.Title>Configuração de imposto</S.Title>
      </S.Header>

      <S.Body>
        <S.Description>
          Configure o imposto para o seu perfil do Taboola. O imposto padrão é de aproximadamente
          13,83%.
        </S.Description>

        <S.NotOperationalCredentialsWrapper>
          <S.Label>Taxa de imposto</S.Label>
          <S.Input
            type="text"
            name="tax_percentage"
            placeholder="13,83"
            prependText="%"
            value={currencyFormatter(taxRate.toString())}
            onChange={onTaxRateChange}
          />
        </S.NotOperationalCredentialsWrapper>

        <S.ConnectProfileButton onClick={handleSave} disabled={isUpdatingTaxRate}>
          {isUpdatingTaxRate ? 'Salvando...' : 'Salvar configuração'}
        </S.ConnectProfileButton>
      </S.Body>
    </S.Modal>
  );
};

export default TaxModal;
